import { Content } from '@phrasee/phrasee-typings'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'

import { startPersonalizationElement } from '../api'
import { contentKeys } from '../queryKeys'

const useStartPersonalizationMutation = () => {
  const queryClient = useQueryClient()

  return useMutation<
    Content,
    { response: { data: { message: string } } },
    Parameters<typeof startPersonalizationElement>[0],
    unknown
  >(startPersonalizationElement, {
    onError: (e) => {
      errorToast(e.response.data.message)
    },
    onSuccess: (content) => {
      queryClient.setQueryData(contentKeys.content(content._id), content)
      queryClient.invalidateQueries(contentKeys.contentLibraryAll())
    },
  })
}

export default useStartPersonalizationMutation
